export interface IChecklistBrilinkProps {
  outerColor?: string;
  checklistColor: string;
  size?: string;
}

ChecklistBrilink.defaultProps = {
  checklistColor: 'white',
  size: '36',
};

export default function ChecklistBrilink(props: IChecklistBrilinkProps) {
  return (
    <svg
      width={props.size}
      height={props.size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18" cy="18" r="18" fill={props.outerColor} />
      <path
        d="M25.9715 12.7164C25.404 12.2131 24.5214 12.2526 24.0028 12.8089L15.4977 21.9452L11.3888 17.8701C10.8464 17.3342 9.96524 17.3261 9.4173 17.8538C8.86795 18.3802 8.85958 19.2412 9.40056 19.7771L14.544 24.8777C14.8075 25.1389 15.1644 25.2844 15.5381 25.2844C15.5464 25.2844 15.5562 25.2844 15.5646 25.2858C15.9494 25.2776 16.3119 25.1171 16.5698 24.8397L26.0662 14.6384C26.5835 14.0807 26.5417 13.221 25.9715 12.7164Z"
        fill={props.checklistColor}
      />
    </svg>
  );
}
